import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Home from '@/components/Home'
import Setpage from '@/components/Setpage'
import RegPage from '@/components/Reg'
import RegTiePage from '@/components/RegTie'
import Clublist from '@/components/clublist'
import Clubdes from '@/components/clubdes'
import Racelist from '@/components/racelist'
import Racedes from '@/components/racedes'
import Shop from '@/components/shop'
import Shopdes from '@/components/shopdes'
import Courselist from '@/components/courselist'
import Shopbuy from '@/components/shopbuy'
import Myselfpage from '@/components/Myselfpage'
import About from '@/components/about'
Vue.use(Router)

export default new Router({
  // mode: 'history', // 或者 'hash'
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
  
    {
      path: '/set',
      name: 'Setpage',
      component: Setpage
    },
    
    {
      path: '/reg',
      name: 'regPage',
      component: RegPage
    },
    {
      path: '/regtie',
      name: 'regTiePage',
      component: RegTiePage
    },
    {
      path: '/clublist',
      name: 'clublist',
      component: Clublist
    },
    {
      path: '/clubdes/:id',
      name: 'clubdes',
      component: Clubdes
    },
    {
      path: '/racelist',
      name: 'racelist',
      component: Racelist
    },
    {
      path: '/racedes/:id',
      name: 'racedes',
      component: Racedes
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop
    },
    {
      path: '/shopdes/:id',
      name: 'shopdes',
      component: Shopdes
    },
    {
      path: '/courselist',
      name: 'courselist',
      component: Courselist
    },
    {
      path: '/shopbuy/:id/:sku',
      name: 'shopbuy',
      component: Shopbuy
    },
    {
      path: '/myselfpage',
      name: 'Myselfpage',
      component: Myselfpage
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 如果存在 savedPosition，则说明是通过浏览器的前进/后退按钮触发的
    // console.log('scrollBehavior called:', { to, from, savedPosition });
    // if (savedPosition) {
    //   return savedPosition;
    // } 
    // 否则，默认滚动到页面顶部
    return { x: 0, y: 0 };
  },
})

// // 兼容性处理：手动滚动到顶部
// Router.afterEach((to, from) => {
//   setTimeout(() => {
//     window.scrollTo(0, 0);
//   }, 0);
// });



// WEBPACK FOOTER //
// ./src/router/index.js